<template>
  <div :id="id">
    <Printer title="Course Staff">
      <template v-slot:printContent>
        <div class="row">
          <card
            header-tag="header"
            class="m-2"
            v-for="s in staff"
            :key="s.Id"
          >
            <div class="text-center">
              <div>
                <img
                  class="bigavatar border-gray"
                  v-if="s.PictureUrl"
                  :src="s.PictureUrl"
                  :title="s.FullName"
                >
                <img
                  class="bigavatar border-gray"
                  v-else
                  src="@/assets/img/image-not-available.png"
                  :title="s.FullName"
                >
              </div>
              <div>
                <b>{{ s.FullName }}</b>
              </div>
              <div v-if="s.Preferred">
                ({{ s.Preferred }})
              </div>
              <div>{{ s.Position }}</div>
            </div>
          </card>
        </div>
      </template>
    </Printer>
  </div>
</template>

<script>
import Printer from '@/components/_main/printer.vue'

export default {
  name: 'StaffBiosPrint',
  components: {
    Printer
  },
  props: {
    staff: {
      type: Array,
      default: function () {
        return []
      }
    },
    id: {
      type: String,
      default: ''
    },
    showPrint: {
      type: Boolean,
      default: undefined
    }
  }
}
</script>
